import { ALLOWED_SERIES, type CardInput, type Series } from "../odp/types.js";

export interface OdpTabState {
  odpFile: File | null;
  odpFileName: string;
  currentCard: CardInput;
  processing: boolean;
  resultBlob: Blob | null;
  resultName: string;
  message: string | null;
  messageType: "info" | "error" | "success";
}

export type OdpAction =
  | { type: "SET_FILE"; file: File; name: string }
  | { type: "CLEAR_FILE" }
  | { type: "SET_CARD_FIELD"; field: Partial<CardInput> }
  | { type: "SET_PROCESSING"; processing: boolean }
  | { type: "SET_RESULT"; blob: Blob; name: string; message: string }
  | { type: "SET_MESSAGE"; message: string | null; messageType: "info" | "error" | "success" };

export function odpReducer(state: OdpTabState, action: OdpAction): OdpTabState {
  switch (action.type) {
    case "SET_FILE":
      return { ...state, odpFile: action.file, odpFileName: action.name, message: null, resultBlob: null };
    case "CLEAR_FILE":
      return { ...state, odpFile: null, odpFileName: "", resultBlob: null, message: null };
    case "SET_CARD_FIELD":
      return { ...state, currentCard: { ...state.currentCard, ...action.field } };
    case "SET_PROCESSING":
      return { ...state, processing: action.processing };
    case "SET_RESULT":
      return {
        ...state,
        processing: false,
        resultBlob: action.blob,
        resultName: action.name,
        message: action.message,
        messageType: "success",
      };
    case "SET_MESSAGE":
      return { ...state, message: action.message, messageType: action.messageType };
  }
}

export function makeInitialOdpState(): OdpTabState {
  return {
    odpFile: null,
    odpFileName: "",
    currentCard: {
      series: ALLOWED_SERIES[0] as Series,
      title: "",
      spec: "多圖",
      description: "",
      images: [],
    },
    processing: false,
    resultBlob: null,
    resultName: "",
    message: null,
    messageType: "info",
  };
}
